export function createVersionDropdown(number_of_versions, current) {
  const dropdownItems = document.querySelector(".dropdown-content");
  for (let i = 1; i <= number_of_versions; i++) {
    const item = document.createElement("li");
    Object.assign(item, {
      className: "dropdown__item",
      textContent: "Version " + i,
    });
    dropdownItems.appendChild(item);
  }
  document.querySelector("#selectedVersion").textContent = "Version " + current;
}

export function toggleDropdown(e) {
  if (!e.target.textContent.includes('Current')) {
    e.target.textContent += ' (Current)';
  } else {
    e.target.textContent = e.target.textContent.split(' (Cu')[0];
  }
  const dropdownItems = document.querySelector(".dropdown-content");
  dropdownItems.classList.toggle("show");
}

export function selectProjectType(e) {
  const element = e.target;
  const text = element.textContent;
  const value = element.getAttribute("data-id");
  const selectedProjectType = document.getElementById("selected-design-type");
  selectedProjectType.textContent = text;
  selectedProjectType.setAttribute("data-id", value);
}

export function toggleSelectProjectDropdown() {
  const dropdownItems = document.querySelector(".dropdown-select");
  dropdownItems.classList.toggle("active");
}
